export const convertUriToHttpsUrl = (uri: string) => {
	const lower = uri.toLowerCase();
	if (lower.includes('http://')) {
		return lower.replace('http://', 'https://');
	} else if (lower.includes('https://')) {
		return lower;
	}
	return `https://${lower}`;
};
